import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-unreviewed-plan",
    prompt: (guidanceItem) => `Please review your ${guidanceItem.parameters.planShortName} plan and make any updates.`,
    openAction: { 
        text: "Where to review plan?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/plans?planId=${guidanceItem.parameters.planId}`,
        row: null
    },
    completeAction: {
    }
});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-unreviewed-plan.js